import { EditorState, NodeSelection, Selection, TextSelection } from 'prosemirror-state'
import { Decoration, DecorationSet, EditorView } from 'prosemirror-view'
import {
  StreamDocContentPluginKey,
  StreamDocContentPluginState,
  StreamDocContentStatus,
} from 'common/Prose/Plugins/StreamDocContent/StreamDocContent'
import { DocStreamingContent } from 'screens/ProseEdit/components/DocStreamingContent/DocStreamingContent'

const getDeco = (pluginState: StreamDocContentPluginState) => (view: EditorView) => {
  const { root, container, status } = pluginState

  if (status === StreamDocContentStatus.streaming) {
    const { jobId, selection } = pluginState

    root.render(
      <>
        {selection && (
          <p data-depth="0">
            <br />
            <br className="ProseMirror-trailingBreak" />
          </p>
        )}
        <DocStreamingContent generationId={jobId} view={view} />
      </>,
    )
  }

  return container
}

export const decorations = (state: EditorState) => {
  const pluginState = StreamDocContentPluginKey.getState(state) as StreamDocContentPluginState

  if (pluginState.status === StreamDocContentStatus.streaming) {
    const selection = Selection.fromJSON(state.doc, pluginState.selection || { type: 'text', anchor: 2, head: 2 })
    let pos = selection.to
    if (selection instanceof TextSelection && !selection.empty) {
      pos = selection.$to.after()
    }
    const decorations = [Decoration.widget(pos, getDeco(pluginState), { key: `streaming-job-${pluginState.jobId}` })]
    const isReplacement = ['replace', 'add_more', 'new_doc'].includes(pluginState.mode)

    if (pluginState.uuid && isReplacement) {
      state.doc.descendants((node, pos) => {
        if (node.attrs.blockId === pluginState.uuid) {
          decorations.push(Decoration.node(pos, pos + node.nodeSize, { style: 'display: none' }))
        }
      })
    } else if (selection instanceof NodeSelection && isReplacement) {
      decorations.push(
        Decoration.node(selection.from, selection.from + selection.node.nodeSize, { style: 'display: none' }),
      )
    }
    return DecorationSet.create(state.doc, decorations)
  }

  return DecorationSet.empty
}
